import React from 'react';
import { node } from 'prop-types';
import cx from 'classnames';
import deviceStatus from 'propTypes/deviceStatus';

import styles from './DeviceContainer.scss';

export default function DeviceContainer({ children, status }) {
  return (
    <div className={styles.main}>
      <div className={cx(styles.content, styles[`status-${status}`])}>
        {children}
      </div>
    </div>
  );
}

DeviceContainer.propTypes = {
  children: node.isRequired,
  status: deviceStatus.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/DataPanel/Details/DeviceContainer/index.js